var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// libs/widgets/src/lib/wallet-manage/wallet-manage.element.ts
import { html as html4, LitElement as LitElement4 } from "lit";
import { customElement as customElement4, property as property3 } from "lit/decorators.js";
import "@one-inch-community/ui-components/card";

// libs/widgets/src/lib/wallet-manage/wallet-manage.style.ts
import { css } from "lit";
var walletManageStyle = css`
  
`;

// libs/widgets/src/lib/wallet-manage/elements/wallet-list/wallet-list.element.ts
import { html as html3, LitElement as LitElement3 } from "lit";
import { customElement as customElement3 } from "lit/decorators.js";
import { map } from "lit/directives/map.js";
import { Task as Task2 } from "@lit/task";

// libs/widgets/src/lib/wallet-manage/elements/wallet-view/wallet-view.element.ts
import { html as html2, LitElement as LitElement2 } from "lit";
import { customElement as customElement2, property as property2, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";

// libs/widgets/src/lib/wallet-manage/elements/wallet-view/wallet-view.style.ts
import { css as css2 } from "lit";
var walletViewStyle = css2`
    
    :host {
        display: block;
        transition: height .2s;
        overflow: hidden;
    }

    .wallet-view-container {
        display: flex;
        align-content: center;
        justify-content: space-between;
        padding: 20px 16px;
        border-radius: 16px;
        transition: background-color .2s, height .2s;
        position: relative;
        overflow: hidden;
        color: var(--color-content-content-primary);
    }

    .wallet-icon {
        width: 24px;
        height: 24px;
    }

    .wallet-name {
        color: var(--color-content-content-primary);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    
    .connect-icon {
        color: var(--color-content-content-primary);
        margin-left: auto;
        transform: scale(0);
        transition: transform .2s;
    }
    
    .connect-icon__connected {
        transform: scale(1);
        transition: color .2s;
        color: var(--color-content-content-primary);
    }
    
    .connect-icon__active {
        transform: scale(1);
        transition: color .2s;
        color: var(--primary);
    }
    
    .data-container {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .loader-icon {
        height: 24px;
        width: 24px;
        margin-left: auto;
    }
    
    .address-list {
        display: flex;
        flex-direction: column;
    }

    inch-wallet-view-address-balance {
        transform: translate3d(24px, 0, 0);
        transition: transform .2s;
        will-change: transform;
    }
    
    .add-connection {
        transition: transform .2s;
        transform: scale(0);
    }

    .address-container__active inch-wallet-view-address-balance {
        transform: translate3d(0, 0, 0);
    }
    
    .wallet-view-container__wc.wallet-view-container__connected:not(.wallet-view-container__loading) .right-data {
        transform: translate3d(36px, 0, 0);
        transition: transform .2s;
    }
    
    .sub-wallet-icon:dir(rtl) {
        transform: scale(-1, 1);
    }
    
    @media (hover: hover) {
        .wallet-view-container:hover {
            background-color: var(--color-background-bg-secondary);
        }
        .wallet-view-container:hover .connect-icon {
            transform: scale(1);
        }
        .wallet-view-container:hover inch-wallet-view-address-balance {
            transform: translate3d(0, 0, 0);
        }
        .wallet-view-container:hover .add-connection {
            transform: scale(1);
        }
        .wallet-view-container:hover.wallet-view-container__wc.wallet-view-container__connected .right-data {
            transform: translate3d(0, 0, 0);
        }
    }
    
    @media (hover: none) {
        .wallet-view-container__wc.wallet-view-container__connected:not(.wallet-view-container__loading) .right-data {
            transform: translate3d(0, 0, 0);
        }

        .add-connection {
            transform: scale(1);
        }
    }

    @keyframes rainbow {
        0% {
            background-position: 0;
        }
        100% {
            background-position: 100%;
        }
    }

`;

// libs/widgets/src/lib/wallet-manage/elements/wallet-view/wallet-view.element.ts
import { formatHex } from "@one-inch-community/core/formatters";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
import { map as litMap } from "lit/directives/map.js";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/button";
import { appendStyle, async, subscribe } from "@one-inch-community/core/lit";
import { tap } from "rxjs";
import { consume as consume2 } from "@lit/context";

// libs/widgets/src/lib/wallet-manage/context.ts
import { createContext } from "@lit/context";
var controllerContext = createContext(Symbol("controller context"));

// libs/widgets/src/lib/wallet-manage/elements/wallet-view-address-balance/wallet-view-address-balance.element.ts
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Task } from "@lit/task";
import { formatUnits } from "viem";

// libs/widgets/src/lib/wallet-manage/elements/wallet-view-address-balance/wallet-view-address-balance.style.ts
import { css as css3 } from "lit";
var walletViewAddressBalanceStyle = css3`

    :host {
        color: var(--color-content-content-primary);
        text-align: right;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }

    .loader {
        will-change: filter;
        height: 20px;
        width: 60px;
        background-color: var(--color-background-bg-secondary);
        border-radius: 4px;
        animation: stub-loader-animation 3s ease-in-out infinite;
    }

    @keyframes stub-loader-animation {
        0%, 100% {
            filter: opacity(1);
        }
        50% {
            filter: opacity(0.5);
        }
    }

`;

// libs/widgets/src/lib/wallet-manage/elements/wallet-view-address-balance/wallet-view-address-balance.element.ts
import { LongTimeCache } from "@one-inch-community/core/cache";
import { getChainById, nativeTokenAddress } from "@one-inch-community/sdk/chain";
import { formatNumber } from "@one-inch-community/core/formatters";
import { consume } from "@lit/context";
import { ApplicationContextToken } from "@one-inch-community/core/application-context";
var storage = new LongTimeCache("inch-wallet-view-address-balance", 7);
var WalletViewAddressBalanceElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.task = new Task(
      this,
      async ([chainId, address]) => {
        if (!chainId || !address) throw new Error("");
        const balanceRecord = await this.applicationContext.tokenController.getTokenBalance(chainId, nativeTokenAddress, address);
        const balance = formatNumber(formatUnits(BigInt(balanceRecord?.amount ?? 0), 18), 6);
        storage.set([this.chainId, this.address].join(":"), balance);
        return balance;
      },
      () => [this.chainId, this.address]
    );
  }
  render() {
    return this.task.render({
      pending: () => this.getLoader(),
      error: () => this.getLoader(),
      complete: (balance) => {
        if (this.chainId === void 0) throw new Error("");
        const chain = getChainById(this.chainId);
        return html`<span>${balance} ${chain.nativeCurrency.symbol}</span>`;
      }
    });
  }
  getLoader() {
    const loader = () => html`<div class="loader"></div>`;
    if (!this.chainId || !this.address) return loader();
    const balance = storage.get([this.chainId, this.address].join(":"));
    const chain = getChainById(this.chainId);
    if (balance) {
      return html`<span>${balance} ${chain.nativeCurrency.symbol}</span>`;
    }
    return loader();
  }
};
WalletViewAddressBalanceElement.tagName = "inch-wallet-view-address-balance";
WalletViewAddressBalanceElement.styles = walletViewAddressBalanceStyle;
__decorateClass([
  property({ type: Number })
], WalletViewAddressBalanceElement.prototype, "chainId", 2);
__decorateClass([
  property({ type: String })
], WalletViewAddressBalanceElement.prototype, "address", 2);
__decorateClass([
  consume({ context: ApplicationContextToken })
], WalletViewAddressBalanceElement.prototype, "applicationContext", 2);
WalletViewAddressBalanceElement = __decorateClass([
  customElement(WalletViewAddressBalanceElement.tagName)
], WalletViewAddressBalanceElement);

// libs/widgets/src/lib/wallet-manage/elements/wallet-view/wallet-view.element.ts
var WalletViewElement = class extends LitElement2 {
  constructor() {
    super(...arguments);
    this.showLoader = false;
    this.isWalletConnected = false;
    this.addressList = null;
    this.activeAddress = null;
    this.showAddresses = false;
    this.isActiveWallet = false;
  }
  firstUpdated() {
    if (!this.info) {
      throw new Error("");
    }
    const providerDataAdapter = this.getController().getDataAdapter(this.info);
    const globalDataAdapter = this.getController().data;
    subscribe(this, [
      providerDataAdapter.isConnected$.pipe(tap((state3) => this.isWalletConnected = state3)),
      providerDataAdapter.activeAddress$.pipe(tap((state3) => this.activeAddress = state3)),
      providerDataAdapter.addresses$.pipe(tap((state3) => this.addressList = !state3.length ? null : state3)),
      globalDataAdapter.chainId$.pipe(tap((state3) => this.chainId = state3 ?? void 0)),
      globalDataAdapter.isActiveWallet$(this.info).pipe(tap((state3) => this.isActiveWallet = state3))
    ], { requestUpdate: false });
  }
  render() {
    if (!this.info) {
      throw new Error("");
    }
    const addressListLength = this.addressList?.length ?? 0;
    const height = (this.showAddresses && addressListLength > 1 ? addressListLength * 64 : 0) + 64;
    appendStyle(this, {
      height: `${height}px`
    });
    const isWalletConnect = this.info.uuid === "walletConnect";
    const classes = {
      "wallet-view-container": true,
      "wallet-view-container__wc": isWalletConnect,
      "wallet-view-container__connected": this.isWalletConnected,
      "wallet-view-container__loading": this.showLoader
    };
    return html2`
      <div class="${classMap(classes)}" @click="${() => this.onClick()}">
        <div class="data-container left-data">
          <img class="wallet-icon" alt="${this.info.name}" src="${this.info.icon}">
          <span class="wallet-name">${this.info.name}</span>
        </div>
        <div class="data-container right-data">
          ${when(this.activeAddress, (address) => html2`
            <span>${formatHex(address)}</span>
          `)}
          ${when(
      this.showLoader,
      () => html2`
              <inch-icon class="loader-icon" icon="fire48"></inch-icon>`,
      () => {
        const classes2 = {
          "connect-icon": true,
          "connect-icon__connected": this.isWalletConnected,
          "connect-icon__active": this.isActiveWallet
        };
        return html2`
                <inch-icon class="${classMap(classes2)}" icon="connect16"></inch-icon>
                ${when(isWalletConnect && this.activeAddress, () => html2`
                  <inch-button @click="${(event) => this.onConnect(event)}" class="add-connection" size="l" type="tertiary">
                    <inch-icon icon="plusCircle16"></inch-icon>
                  </inch-button>
                `)}
              `;
      }
    )}
        </div>
      </div>


      ${when(
      this.addressList && this.addressList.length > 1,
      () => html2`
          <div class="address-list">
            ${litMap(this.addressList, (address) => {
        return html2`
                <div @click="${() => this.setActiveAddress(address)}" class="wallet-view-container address-container ${async(this.isActiveAddress(address).then((state3) => state3 ? "address-container__active" : ""))}">
                  <div class="data-container left-data">
                    <inch-icon class="sub-wallet-icon" icon="cornerDownRight16"></inch-icon>
                    <span>${formatHex(address, { width: this.offsetWidth })}</span>
                  </div>
                  <div class="data-container right-data">
                    <inch-wallet-view-address-balance chainId="${ifDefined(this.chainId)}" address="${address}"></inch-wallet-view-address-balance>
                    <inch-icon class="connect-icon ${async(this.isActiveAddress(address).then((state3) => state3 ? "connect-icon__active" : ""))}" icon="link16"></inch-icon>
                  </div>
                </div>
              `;
      })}
          </div>
        `
    )}
    `;
  }
  async onClick() {
    if (this.isWalletConnected) {
      if (this.addressList && this.addressList.length === 1) {
        await this.setActiveAddress(this.addressList[0]);
        return;
      }
      this.showAddresses = !this.showAddresses;
      return;
    }
    await this.onConnect();
  }
  async onConnect(event) {
    if (!this.info || this.showLoader) return;
    event?.preventDefault();
    event?.stopPropagation();
    this.showLoader = true;
    const isWalletConnect = this.info.uuid === "walletConnect";
    if (this.isWalletConnected && isWalletConnect) {
      this.showAddresses = await this.getController().addConnection(this.info);
    } else {
      this.showAddresses = await this.getController().connect(this.info);
    }
    this.showLoader = false;
  }
  async setActiveAddress(address) {
    if (!this.info) return;
    await this.getController().setActiveAddress(this.info, address);
  }
  getController() {
    if (!this.controller) {
      throw new Error("");
    }
    return this.controller;
  }
  isActiveAddress(address) {
    if (!this.info) throw new Error("");
    return this.getController().data.isActiveAddress(this.info, address);
  }
};
WalletViewElement.tagName = "inch-wallet-view";
WalletViewElement.styles = walletViewStyle;
__decorateClass([
  property2({ type: Object })
], WalletViewElement.prototype, "info", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "showLoader", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "isWalletConnected", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "addressList", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "activeAddress", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "showAddresses", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "isActiveWallet", 2);
__decorateClass([
  state()
], WalletViewElement.prototype, "chainId", 2);
__decorateClass([
  consume2({ context: controllerContext })
], WalletViewElement.prototype, "controller", 2);
WalletViewElement = __decorateClass([
  customElement2(WalletViewElement.tagName)
], WalletViewElement);

// libs/widgets/src/lib/wallet-manage/elements/wallet-list/wallet-list.element.ts
import { consume as consume3 } from "@lit/context";
import "@one-inch-community/ui-components/icon";
import "@one-inch-community/ui-components/scroll";
var WalletListElement = class extends LitElement3 {
  constructor() {
    super(...arguments);
    this.task = new Task2(
      this,
      async () => await this.getController().getSupportedWallets(),
      () => []
    );
  }
  render() {
    return this.task.render({
      pending: () => html3`<inch-icon icon="unicornRun"></inch-icon>`,
      complete: (infoList) => html3`
        <inch-scroll-view-consumer>
          ${map(infoList, (info) => html3`<inch-wallet-view .info="${info}"></inch-wallet-view>`)}
        </inch-scroll-view-consumer>
      `
    });
  }
  getController() {
    if (!this.controller) {
      throw new Error("");
    }
    return this.controller;
  }
};
WalletListElement.tagName = "inch-wallet-list";
__decorateClass([
  consume3({ context: controllerContext })
], WalletListElement.prototype, "controller", 2);
WalletListElement = __decorateClass([
  customElement3(WalletListElement.tagName)
], WalletListElement);

// libs/widgets/src/lib/wallet-manage/wallet-manage.element.ts
import { ContextProvider } from "@lit/context";
import { getMobileMatchMedia, changeMobileMatchMedia } from "@one-inch-community/core/lit";
import { ifDefined as ifDefined2 } from "lit/directives/if-defined.js";
var WalletManageElement = class extends LitElement4 {
  constructor() {
    super(...arguments);
    this.mobileMedia = getMobileMatchMedia();
    this.context = new ContextProvider(this, { context: controllerContext });
  }
  firstUpdated() {
    changeMobileMatchMedia(this);
  }
  render() {
    if (!this.controller) {
      throw new Error("For the inch-wallet-manage widget to work, you need to pass the controller corresponding to the interface in the controller field");
    }
    if (!this.context.value) {
      this.context.setValue(this.controller);
    }
    const headerText = this.controller.isConnected ? "Wallet management" : "Connect wallet";
    return html4`
      <inch-card showShadow="${ifDefined2(this.showShadow)}" forMobileView="${ifDefined2(this.mobileMedia.matches ? "" : void 0)}">
        <inch-card-header closeButton headerText="${headerText}"></inch-card-header>
        <inch-wallet-list></inch-wallet-list>
      </inch-card>
    `;
  }
};
WalletManageElement.tagName = "inch-wallet-manage";
WalletManageElement.styles = walletManageStyle;
__decorateClass([
  property3({ type: Object, attribute: false })
], WalletManageElement.prototype, "controller", 2);
__decorateClass([
  property3({ type: Boolean })
], WalletManageElement.prototype, "showShadow", 2);
WalletManageElement = __decorateClass([
  customElement4(WalletManageElement.tagName)
], WalletManageElement);

// libs/widgets/src/lib/wallet-manage/connect-wallet-view.element.ts
import { html as html5, LitElement as LitElement5 } from "lit";

// libs/widgets/src/lib/wallet-manage/connect-wallet-view.style.ts
import { css as css4 } from "lit";
import { mobileMediaCSS } from "@one-inch-community/core/lit";
var connectWalletViewStyle = css4`

    .connect-wallet-view-container {
        padding: 8px 5px 8px 8px;
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 12px;
        background: var(--color-background-bg-primary);
        height: 40px;
        box-sizing: border-box;
    }

    .connect-wallet-view-icon {
        width: 24px;
        height: 24px;
    }
    
    ${mobileMediaCSS(css4`
        .connect-wallet-view-container {
            padding: 6px;
            width: 36px;
            height: 36px;
        }
    `)}

`;

// libs/widgets/src/lib/wallet-manage/connect-wallet-view.element.ts
import { customElement as customElement5, property as property4 } from "lit/decorators.js";
import { observe, getMobileMatchMediaAndSubscribe } from "@one-inch-community/core/lit";
import { OverlayController } from "@one-inch-community/ui-components/overlay";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/ui-components/icon";
import { defer, map as map2 } from "rxjs";
import { formatHex as formatHex2 } from "@one-inch-community/core/formatters";
import { CacheActivePromise } from "@one-inch-community/core/decorators";
import { when as when2 } from "lit/directives/when.js";
var ConnectWalletViewElement = class extends LitElement5 {
  constructor() {
    super(...arguments);
    this.mobileMatchMedia = getMobileMatchMediaAndSubscribe(this);
    this.overlay = new OverlayController(
      "#app-root",
      this
    );
    this.overlayId = null;
    this.chainId$ = defer(() => this.getController().data.chainId$);
    this.activeAddress$ = defer(() => this.getController().data.activeAddress$);
    this.info$ = defer(() => this.getController().data.info$);
    this.icon$ = this.info$.pipe(map2((item) => item.icon));
    this.name$ = this.info$.pipe(map2((item) => item.name));
    this.activeAddressView$ = this.activeAddress$.pipe(map2((address) => {
      return address && formatHex2(address);
    }));
    this.view$ = defer(() => this.getController().data.isConnected$).pipe(
      map2((isConnected) => {
        return isConnected ? this.getConnectedView() : this.getConnectWalletButton();
      })
    );
  }
  render() {
    return html5`${observe(this.view$)}`;
  }
  getConnectedView() {
    return html5`
      <div class="connect-wallet-view-container" @click="${() => this.mobileMatchMedia.matches && this.onOpenConnectView()}">
        <img class="connect-wallet-view-icon" alt="${observe(this.name$)}" src="${observe(this.icon$)}">
        ${when2(!this.mobileMatchMedia.matches, () => html5`
          <inch-wallet-view-address-balance address="${observe(this.activeAddress$)}" chainId="${observe(this.chainId$)}"></inch-wallet-view-address-balance>
          <inch-button @click="${() => this.onOpenConnectView()}" type="secondary" size="m">
            ${observe(this.activeAddressView$)}
          </inch-button>
        `)}
      </div>
    `;
  }
  getConnectWalletButton() {
    return html5`
      <inch-button
        @click="${() => this.onOpenConnectView()}"
        type="${this.mobileMatchMedia.matches ? "primary-gray" : "secondary"}"
        size="${this.mobileMatchMedia.matches ? "l" : "xl"}"
      >
        ${when2(
      this.mobileMatchMedia.matches,
      () => html5`<inch-icon icon="wallet24"></inch-icon>`,
      () => html5`<span>Connect wallet</span>`
    )}
      </inch-button>
    `;
  }
  getController() {
    if (!this.controller) {
      throw new Error("");
    }
    return this.controller;
  }
  async onOpenConnectView() {
    if (this.overlay.isOpen) {
      await this.overlay.close(this.overlayId ?? 0);
      this.overlayId = null;
      return;
    }
    this.overlayId = await this.overlay.open(html5`
      <inch-wallet-manage @closeCard="${() => {
      if (!this.overlayId) return;
      this.overlay.close(this.overlayId);
      this.overlayId = null;
    }}" .controller="${this.controller}" ></inch-wallet-manage>
    `);
  }
};
ConnectWalletViewElement.tagName = "inch-connect-wallet-view";
ConnectWalletViewElement.styles = connectWalletViewStyle;
__decorateClass([
  property4({ type: Object, attribute: false })
], ConnectWalletViewElement.prototype, "controller", 2);
__decorateClass([
  CacheActivePromise()
], ConnectWalletViewElement.prototype, "onOpenConnectView", 1);
ConnectWalletViewElement = __decorateClass([
  customElement5(ConnectWalletViewElement.tagName)
], ConnectWalletViewElement);

// libs/widgets/src/lib/wallet-manage/chain-selector.element.ts
import { html as html8, LitElement as LitElement8 } from "lit";
import { customElement as customElement8, property as property7 } from "lit/decorators.js";
import "@one-inch-community/ui-components/button";
import "@one-inch-community/ui-components/icon";
import { observe as observe2, getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe4 } from "@one-inch-community/core/lit";

// libs/widgets/src/lib/wallet-manage/chain-selector.style.ts
import { css as css5 } from "lit";
var chainSelectorStyle = css5`

    .unsupported {
        color: var(--color-core-red-critical);
    }
    
`;

// libs/widgets/src/lib/wallet-manage/chain-selector.element.ts
import { defer as defer2, filter, map as map3 } from "rxjs";
import { when as when4 } from "lit/directives/when.js";
import { OverlayController as OverlayController2 } from "@one-inch-community/ui-components/overlay";

// libs/widgets/src/lib/wallet-manage/chain-view-config.ts
import { ChainId } from "@one-inch-community/models";
import { isL2Chain } from "@one-inch-community/sdk/chain";
import { isSupportFusion } from "@one-inch-community/sdk/swap";
var chainViewConfig = {
  [ChainId.eth]: { name: "Ethereum", iconName: "eth24" },
  [ChainId.arbitrum]: { name: "Arbitrum", iconName: "arbitrum24" },
  [ChainId.op]: { name: "Optimism", iconName: "op24" },
  [ChainId.zkSyncEra]: { name: "zkSync Era", iconName: "zkSyncEra24" },
  [ChainId.bnb]: { name: "BNB Smart Chain", iconName: "bnb24", priority: 1 },
  [ChainId.matic]: { name: "Polygon", iconName: "matic24", priority: 1 },
  [ChainId.gnosis]: { name: "Gnosis", iconName: "gnosis24" },
  [ChainId.avalanche]: { name: "Avalanche", iconName: "avalanche24" },
  [ChainId.fantom]: { name: "Fantom", iconName: "fantom24" },
  [ChainId.aurora]: { name: "Aurora", iconName: "aurora24" },
  [ChainId.klaytn]: { name: "Klaytn", iconName: "klaytn24" }
};
var chainList = Object.keys(chainViewConfig).filter((chainId) => isSupportFusion(+chainId)).map((chainId) => ({ ...chainViewConfig[chainId], chainId: Number(chainId) })).sort((info1, info2) => {
  if (info1.chainId == ChainId.eth) return -1;
  if (info2.chainId == ChainId.eth) return 1;
  if (isL2Chain(info1.chainId)) return -1;
  if (isL2Chain(info2.chainId)) return 1;
  return (info2.priority ?? 0) - (info1.priority ?? 0);
});

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list/chain-selector-list.element.ts
import { html as html7, LitElement as LitElement7 } from "lit";

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list/chain-selector-list.style.ts
import { css as css6 } from "lit";
var chainSelectorListStyle = css6`

    .card {
        height: 100%;
    }

    .scroll-container {
        position: relative;
        height: 100%;
        overflow-y: auto;
    }

    .scroll-overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

`;

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list/chain-selector-list.element.ts
import { customElement as customElement7, property as property6, state as state2 } from "lit/decorators.js";
import { ifDefined as ifDefined3 } from "lit/directives/if-defined.js";
import "@one-inch-community/ui-components/card";
import { getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe3, subscribe as subscribe2 } from "@one-inch-community/core/lit";
import "@one-inch-community/ui-components/scroll";

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list-item/chain-selector-list-item.element.ts
import { html as html6, LitElement as LitElement6 } from "lit";

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list-item/chain-selector-list-item.style.ts
import { mobileMediaCSS as mobileMediaCSS2 } from "@one-inch-community/core/lit";
import { css as css7 } from "lit";
var chainSelectorListItemStyle = css7`
    
    :host {
        width: 100%;
        height: 100%;
    }

    .container {
        display: flex;
        align-items: center;
        gap: 8px;
        height: 40px;
        padding: 0 8px;
        border-radius: 12px;
        background-color: transparent;
        transition: background-color .2s;
        color: var(--color-content-content-primary);
        font-size: 14px;
    }
    
    .active .list-icon {
        transform: scale(1);
        color: var(--primary);
    }
    
    .list-icon {
        margin-left: auto;
        transition: transform .2s;
        transform: scale(0);
    }
    
    @media (hover: hover) {
        .container:hover {
            background-color: var(--color-background-bg-secondary);
        }
        .container:hover .list-icon {
            transform: scale(1);
        }
    }

    .container:active {
        background-color: var(--color-background-bg-secondary);
    }

    ${mobileMediaCSS2(css7`
        .container {
            height: 50px;
            font-size: 16px;
        }
    `)}

`;

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list-item/chain-selector-list-item.element.ts
import { customElement as customElement6, property as property5 } from "lit/decorators.js";
import { classMap as classMap2 } from "lit/directives/class-map.js";
import "@one-inch-community/ui-components/icon";
import { isL2Chain as isL2Chain2 } from "@one-inch-community/sdk/chain";
import { dispatchEvent, getMobileMatchMediaAndSubscribe as getMobileMatchMediaAndSubscribe2, isRTLCurrentLocale } from "@one-inch-community/core/lit";
import { when as when3 } from "lit/directives/when.js";
var ChainSelectorListItemElement = class extends LitElement6 {
  constructor() {
    super(...arguments);
    this.mobileMedia = getMobileMatchMediaAndSubscribe2(this);
  }
  render() {
    if (!this.info) return;
    const isL2 = isL2Chain2(this.info.chainId);
    const isActiveChain = Number(this.info.chainId) === this.activeChainId;
    const classes = {
      container: true,
      active: isActiveChain
    };
    const iconSize = this.mobileMedia.matches ? 26 : 24;
    return html6`
      <div class="${classMap2(classes)}" @click="${() => this.setChainId()}">
        ${when3(isL2, () => html6`<inch-icon icon="${isRTLCurrentLocale() ? "l2ChainRTL24" : "l2Chain24"}"></inch-icon>`)}
        <inch-icon width="${iconSize}px" height="${iconSize}px" icon="${this.info.iconName}"></inch-icon>
        <span>${this.info.name}</span>
        <inch-icon class="list-icon" icon="link16"></inch-icon>
      </div>
    `;
  }
  async setChainId() {
    if (!this.info) throw new Error("");
    await this.controller?.changeChain(this.info.chainId);
    dispatchEvent(this, "closeCard", null);
  }
};
ChainSelectorListItemElement.tagName = "inch-chain-selector-list-item";
ChainSelectorListItemElement.styles = chainSelectorListItemStyle;
__decorateClass([
  property5({ type: Object })
], ChainSelectorListItemElement.prototype, "info", 2);
__decorateClass([
  property5({ type: Number })
], ChainSelectorListItemElement.prototype, "activeChainId", 2);
__decorateClass([
  property5({ type: Object, attribute: false })
], ChainSelectorListItemElement.prototype, "controller", 2);
ChainSelectorListItemElement = __decorateClass([
  customElement6(ChainSelectorListItemElement.tagName)
], ChainSelectorListItemElement);

// libs/widgets/src/lib/wallet-manage/elements/chain-selector-list/chain-selector-list.element.ts
import { tap as tap2 } from "rxjs";
var ChainSelectorListElement = class extends LitElement7 {
  constructor() {
    super(...arguments);
    this.mobileMedia = getMobileMatchMediaAndSubscribe3(this);
  }
  firstUpdated() {
    if (!this.controller) throw new Error("");
    subscribe2(this, [
      this.controller.data.chainId$.pipe(tap2((chainId) => this.activeChainId = chainId ?? void 0))
    ], { requestUpdate: false });
  }
  render() {
    return this.mobileMedia.matches ? this.getMobileList() : this.getDesktopList();
  }
  getList() {
    return chainList.map((info) => html7`
      <inch-chain-selector-list-item
        .info="${info}"
        .controller="${this.controller}"
        activeChainId="${ifDefined3(this.activeChainId)}"
      ></inch-chain-selector-list-item>
    `);
  }
  getMobileList() {
    return html7`
      <inch-card class="card" forMobileView>
        <inch-card-header closeButton headerText="Select chain"></inch-card-header>
        <inch-scroll-view-consumer >
          ${this.getList()}
        </inch-scroll-view-consumer>
      </inch-card>
    `;
  }
  getDesktopList() {
    return html7`
      <inch-card>
        ${this.getList()}
      </inch-card>
    `;
  }
};
ChainSelectorListElement.tagName = "inch-chain-selector-list";
ChainSelectorListElement.styles = [
  chainSelectorListStyle
];
__decorateClass([
  property6({ type: Object, attribute: false })
], ChainSelectorListElement.prototype, "controller", 2);
__decorateClass([
  state2()
], ChainSelectorListElement.prototype, "activeChainId", 2);
ChainSelectorListElement = __decorateClass([
  customElement7(ChainSelectorListElement.tagName)
], ChainSelectorListElement);

// libs/widgets/src/lib/wallet-manage/chain-selector.element.ts
import { CacheActivePromise as CacheActivePromise2 } from "@one-inch-community/core/decorators";
var ChainSelectorElement = class extends LitElement8 {
  constructor() {
    super(...arguments);
    this.mobileMedia = getMobileMatchMediaAndSubscribe4(this);
    this.overlay = new OverlayController2("#app-root", this);
    this.overlayId = null;
    this.chainId$ = defer2(() => this.getController().data.chainId$);
    this.unsupportedChainId$ = this.chainId$.pipe(
      map3((chainId) => !!chainId && !!chainViewConfig[chainId] ? "" : "unsupported")
    );
    this.chainIdIconName$ = this.chainId$.pipe(
      filter(Boolean),
      map3((chainId) => {
        if (!chainViewConfig[chainId]) return "alert24";
        return chainViewConfig[chainId].iconName;
      })
    );
    this.chainIdName$ = this.chainId$.pipe(
      filter(Boolean),
      map3((chainId) => {
        if (!chainViewConfig[chainId]) return "Unsupported chain";
        return chainViewConfig[chainId].name;
      })
    );
  }
  render() {
    return html8`
      <inch-button @click="${() => this.onClick()}" size="l" type="primary-gray">
        <inch-icon class="${observe2(this.unsupportedChainId$)}" icon="${observe2(this.chainIdIconName$)}"></inch-icon>
        ${when4(!this.mobileMedia.matches, () => html8`
          <span>${observe2(this.chainIdName$)}</span>
          <inch-icon icon="chevronDown16"></inch-icon>
        `)}
      </inch-button>
    `;
  }
  async onClick() {
    if (this.overlay.isOpenOverlay(this.overlayId ?? 0)) {
      this.closeOverlay();
      return;
    }
    this.overlayId = await this.overlay.open(html8`
      <inch-chain-selector-list
        .controller="${this.controller}"
        @closeCard="${() => this.closeOverlay()}"
      ></inch-chain-selector-list>
    `);
  }
  closeOverlay() {
    if (!this.overlayId) return;
    this.overlay.close(this.overlayId);
    this.overlayId = null;
  }
  getController() {
    if (!this.controller) {
      throw new Error("");
    }
    return this.controller;
  }
};
ChainSelectorElement.tagName = "inch-chain-selector";
ChainSelectorElement.styles = chainSelectorStyle;
__decorateClass([
  property7({ type: Object, attribute: false })
], ChainSelectorElement.prototype, "controller", 2);
__decorateClass([
  CacheActivePromise2()
], ChainSelectorElement.prototype, "onClick", 1);
ChainSelectorElement = __decorateClass([
  customElement8(ChainSelectorElement.tagName)
], ChainSelectorElement);
export {
  ChainSelectorElement,
  ChainSelectorListElement,
  ConnectWalletViewElement,
  WalletManageElement
};
//# sourceMappingURL=index.esm.js.map
